import axios from 'axios';

import { useServicerStore } from '../store';

const VendorService = {
  async getVendors({ type, loanId }) {
    const response = await axios.get('/vendor', {
      params: {
        servicer_id: useServicerStore.getState()?.servicerId,
        type,
        loan_id: loanId,
      },
    });

    return response.data;
  },

  async getVendor(id) {
    const response = await axios.get(`/vendor/${id}`);

    return response.data;
  },

  async createVendor(formValues) {
    const response = await axios.post('/vendor', {
      ...formValues,
      servicer_id: useServicerStore.getState()?.servicerId,
    });

    return response.data;
  },

  async updateVendor({ id, formValues }) {
    const response = await axios.patch(`/vendor/${id}`, formValues);

    return response.data;
  },

  async getVendorBillPayments({ vendorId, page, limit }) {
    const response = await axios.get(`/vendor/${vendorId}/bill_payments`, {
      params: {
        page,
        per_page: limit,
      },
    });

    return response.data;
  },

  async getVendorContacts(vendorId) {
    const response = await axios.get(`/vendor/${vendorId}/vendor_contacts`);

    return response.data;
  },

  async getVendorInsurances(vendorId) {
    const response = await axios.get(`/vendor/${vendorId}/insurance`);

    return response.data;
  },
};

export default VendorService;
